<template>
    <van-popup
        position="bottom"
        closeable
        round
        @close="closeModal"
        class="mianliao-info-modal"
        :style="{ 'max-height': '90%','overflow':'hidden'}"
        v-model="productModalshow"
    >
        <div>
            <div class="title">{{ productInfo.number }}</div>
            <div style="justify-content: flex-start;" class="flex-box">

                <img class='product-avatar' :src="productInfo.curtainImageUrl1"/>
                <!--<div class="bottom-info" style="font-size: 14px;">
                  <span >38</span>#蓝莓之夜
                </div>-->
            </div>
        </div>
        <van-popup @close="closeLinCaiModal" closeable v-model="showPicker" round position="bottom">
             <van-empty v-if="list.length==0">没有数据</van-empty>
            <div style="padding-top:30px;max-height:50vh;min-height:200px;overflow-y: auto;">
                <van-cell @click="onSelect(item)" v-for="(item,index) in list" :key="index" :title="'米数：'+item.value"
                          :label="'批号：'+item.text">
                    <template #right-icon>
                        <van-icon v-if="itemIsSelected(item.id)" name="success"/>
                    </template>
                </van-cell>
            </div>
            <van-button @click="confirmLinCai" color="#f24749" type="primary" block>确定</van-button>
        </van-popup>
        <van-cell-group>
            <van-cell v-if="!showPicker" @click="showPickerAction" title="整卷米数"
                      :value="selectedLinCai.length==0?'请选择':selectedLinCaiValues" is-link>

            </van-cell>
        </van-cell-group>
        <van-cell-group>
            <van-field v-model="lincai" label="零裁米数" placeholder="">
                <template #extra>
                    <span>米</span>
                </template>
            </van-field>
        </van-cell-group>
        <div class="desc">
            <div>
                <van-field
                    v-model="desc"
                    rows="2"
                    autosize
                    label="备注信息"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入重要的备注信息"
                    style="text-align:right"
                />
            </div>
        </div>

        <van-button @click="onConfirm" color="#f24749" type="primary" block>确认下单</van-button>
    </van-popup>
</template>
<script>
import {Toast} from "vant";

export default {
    props: {

        productModalshow: {
            type: Boolean,
            required: true,
            default: false,
        },
        productInfo: {
            type: Object,
            default: {
                list: []

            }

        },
    },

    data() {
        return {
            list: [],
            showPicker: false,
            selectedLinCai: [],
            desc: "",
            lincai: 0,
        };
    },
    computed: {
        selectedLinCaiValues() {
            return this.selectedLinCai.map((item) => item.value).join('，')
        }
    },
    mounted() {
    },
    methods: {
        confirmLinCai() {
            this.showPicker = false;
        },
        showPickerAction() {

            this.getLinCaiData()
            this.showPicker = true
        },
        itemIsSelected(id) {
            return this.selectedLinCai.findIndex((item1) => item1.id == id) > -1
        },
        getLinCaiData() {
            this.$http.post("private/inventoryList", this.productInfo.id).then(res => {
                res = res || []
                this.list = res.map((item) => {
                    return {
                        text: item.batchNumber,
                        value: item.qty,
                        id: item.id,
                        uniqueCode: item.uniqueCode,
                    }
                })
            });
            // this.list = [{text:"批次2022",id:1,value:"53.2米"},{text:"批次2022",id:2,value:"53.2米"},{id:3,text:"批次2022",value:"53.2米"}]
        },
        onConfirm() {

            this.$emit("setModalState", false)
            // this.$emit("setFormData", {selectedLinCai: this.selectedLinCai, lincai: this.lincai, desc: this.desc})
            this.curtainFabricCarAdd()
        },
        curtainFabricCarAdd() {
            let fabricModel = {
                shoppingCarId: 0,
                productId: this.productInfo.id,
                productNumber: this.productInfo.number,
                quantity: this.lincai,
                memo: this.desc
            }
            let param = this.selectedLinCai.map((item) => {
                return {
                    ...fabricModel,
                    batchNUumber: item.text,
                    quantity: item.value,
                    uniqueCode: item.uniqueCode
                }
            })
            param.push(fabricModel)
            this.$http.post("private/fabricShoppingCar/add",param).then(res => {
                // console.log(res, 222)
              if(res) Toast(res || '提交成功');
                  // this.$router.replace('/cart?activeHeader=mianliao')
            })
        },
        onSelect(item) {
            var index = this.selectedLinCai.findIndex((item1) => item1.id == item.id)
            if (index > -1) {
                this.selectedLinCai.splice(index, 1)
            } else {
                this.selectedLinCai = this.selectedLinCai.concat([item]);
            }
        },
        closeLinCaiModal() {

            this.showPicker = false
        },
        closeModal() {

            this.$emit("setModalState", false);
        },
        ok() {
            this.$emit("saveMianLiao");
        }
    }
};
</script>
<style scoped>
.mianliao-info-modal {
    z-index: 2003;
    padding: 10px;
    box-sizing: border-box;
}

.mianliao-info-modal .van-cell {
    align-items: center;
}

.mianliao-info-modal .van-cell__title {
    flex: 0 0 100px;
}

.mianliao-info-modal .van-cell__value {
    text-align: left;
}

.product-avatar {
    max-width: 120px;
    height: 120px;
    margin-right: 20px;
}

.title {
    font-size: 16px;
    /* font-weight: 600; */
    margin-bottom: 5px;
}

.flex-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    position: relative;
}

.m-b-5 {
    margin-bottom: 10px;
}

.values {
    display: flex;
    flex-wrap: wrap;
}

.feilds {
    max-height: calc(80vh - 210px);
    overflow-y: auto;
}

.field .label {
    margin-bottom: 10px;
    font-size: 12px;
    margin-top: 10px;
}

.bottom-info {
    position: absolute;
    color: #fff;
    background: #333333cc;
    padding: 3px 5px;
    bottom: 0;
    font-size: 10px;
    left: 0;
}

.bottom-info span {
    font-size: 24px;
}

</style>
